import ImagesAndCaption from './imagesAndCaption'

export default ImagesAndCaption
